/** Nav-aligned EDR module ids used for preview fixtures and banners. */
export const EDR_MODULE_IDS = [
  'reseller-dashboard',
  'sub-org-dashboard',
  'clients',
  'endpoints',
  'configuration-compliance',
  'malware-detection',
  'automated-response',
  'file-integrity-monitoring',
  'threat-hunting',
  'vulnerability-detection',
  'mitre-attck',
] as const;

export type EdrModuleId = (typeof EDR_MODULE_IDS)[number];

/** Map an EDR pathname to its module id (detail routes inherit parent module). */
export const getEdrModuleIdFromPath = (pathname: string): EdrModuleId | null => {
  if (!pathname.includes('/security/edr/')) return null;

  if (pathname.includes('/reseller-dashboard')) return 'reseller-dashboard';
  if (pathname.includes('/sub-org-dashboard')) return 'sub-org-dashboard';
  if (pathname.includes('/clients')) return 'clients';
  if (pathname.includes('/endpoints') || pathname.includes('/deploy-agent')) {
    return 'endpoints';
  }
  if (pathname.includes('/configuration-compliance')) return 'configuration-compliance';
  if (pathname.includes('/malware-detection')) return 'malware-detection';
  if (pathname.includes('/automated-response')) return 'automated-response';
  if (pathname.includes('/file-integrity-monitoring')) return 'file-integrity-monitoring';
  if (pathname.includes('/threat-hunting')) return 'threat-hunting';
  if (pathname.includes('/vulnerability-detection')) return 'vulnerability-detection';
  if (pathname.includes('/mitre-attck')) return 'mitre-attck';

  return null;
};

export const isEdrPath = (pathname: string): boolean => pathname.includes('/security/edr/');

/** Load org subscription entitlements for all Security routes (nav, guards, EDR modules). */
export const isSecuritySubscriptionPath = (pathname: string): boolean =>
  pathname.includes('/mindtime/security');
